import { window } from '../../../globals';
import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type {
  UpdateOrganizationSBOMReportDefaultsRequest,
  UpdateOrganizationSBOMReportDefaultsResponse,
} from '../../../../shared/types/routes/organizations';

type UpdateOrganizationSBOMReportDefaultsParams = {
  organizationId: number;
  sbomReportAuthorName: string | null;
  sbomReportAuthorEmail: string | null;
  sbomReportSupplier: string | null;
};

async function updateOrganizationSBOMReportDefaults({
  organizationId,
  sbomReportAuthorName,
  sbomReportAuthorEmail,
  sbomReportSupplier,
}: UpdateOrganizationSBOMReportDefaultsParams): Promise<void> {
  await put<UpdateOrganizationSBOMReportDefaultsRequest, UpdateOrganizationSBOMReportDefaultsResponse>(
    `/api/organizations/${organizationId}/sbomReportDefaults`,
    {
      sbomReportAuthorName,
      sbomReportAuthorEmail,
      sbomReportSupplier,
    },
  );
}

/**
 * Hook for updating organization-level SBOM report author defaults.
 */
export default function useUpdateOrganizationSBOMReportDefaults() {
  return useToastedMutation({
    mutationFn: updateOrganizationSBOMReportDefaults,
    successToastMessage: 'SBOM report defaults updated successfully',
    errorToastMessage: 'Failed to update SBOM report defaults',
    onSuccess: (_result, variables) => {
      if (window.user?.organization) {
        window.user.organization.sbomReportAuthorName = variables.sbomReportAuthorName;
        window.user.organization.sbomReportAuthorEmail = variables.sbomReportAuthorEmail;
        window.user.organization.sbomReportSupplier = variables.sbomReportSupplier;
      }

      void queryClient.invalidateQueries({ queryKey: ['organization'] });
    },
  });
}
